import SubmitAnswerRequestDto from "../generated/src/model/SubmitAnswerRequestDto";
import { isApiSuccess, getErrorMessage } from "../utils/error-handler";

export function createUserAnswerApiAdapter(gameSessionApi) {
  return {
    submitAnswer: ({ sessionId, pageId, questionId, answerId }) =>
      new Promise((resolve, reject) => {
        const dto = new SubmitAnswerRequestDto();
        dto.sessionId = sessionId;
        dto.pageId = pageId;
        dto.questionId = questionId;
        dto.answerId = answerId;
        gameSessionApi.submitAnswer(dto, (error, data, response) => {
          if (isApiSuccess(error, response, 200)) {
            resolve(data);
          } else {
            reject(new Error(getErrorMessage(error, response)));
          }
        });
      }),
  };
}
